import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProcessoQuestaoService } from '../../../services/processo-questao.service';
import { ProcessoQuestao } from '../../../models/processo-questao.model';

@Component({
  selector: 'app-processo-questao-list',
  templateUrl: './processo-questao-list.component.html',
  styleUrls: ['./processo-questao-list.component.scss']
})

export class ProcessoQuestaoListComponent extends BaseListComponent<ProcessoQuestao> implements OnInit  {

  mainList: ProcessoQuestao[];
  typeList: any;
  activeList: any;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ProcessoQuestaoService,
  ) {
    super();
  }
  
  ngOnInit() {
    this.loading();
    this.initLoadDataTable();
  }

  initLoadDataTable() {
  
    this.addSub(
      this.myService.findAll().subscribe({
        next: (res) => {
          this.mainList = res['mainList'];
          this.typeList = res['typeList'];
          this.activeList = res['activeList'];
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error?.error.message);
        },
      })
    )
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }

  novo() {
    return ['/pre-projeto/admin/processo-questao/adicionar'];
  }

}
